/**
 * ContactFormPopUp.vue Bootstrap File
 *
 * @project Codendot
 * @company Codendot <https://codendot.com>
 * @author Jawdat Sobh <jawdat@codendot.com>
 * @since Monday, February 20, 2023, 11:36 AM GMT+2
 *
 */
import { App } from "@/lib/app"
import { createRouter, createWebHashHistory } from "vue-router"
import List from "@/tiers/frontend/components/contact-form/List.vue"
import Form from "@/tiers/frontend/components/contact-form/Form.vue"
import { createPinia } from 'pinia'

export default function (app: App) {

    const routes = [
        { path: '/', component: List, name: 'contact' },
        { path: '/form/:title', component: Form, name: 'form' },
    ]
    const pinia = createPinia()
    const router = createRouter({
        history: createWebHashHistory(),
        routes, 
    })

    app.events.mount.listen(({ vue }) => {
        vue.use(router)
        vue.use(pinia)
    })
}